import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Polyline, Marker, Popup, useMap } from 'react-leaflet';
import {
    redMarker,
    greenMarker,
    orangeFilledMarker,
    purpleMarker,
    blueGreenMarker,
} from '../../../../components/Map/MarkerIcons';
import moment from 'moment';
import { getTimeAsDuration, getTimeDifference } from '../../../../utils/helper';

interface StartPointMarkerProps {
    trackData?: any;
    aggregatedTrackData?: any;
    events?: any;
}

const StartPointMarker: React.FC<StartPointMarkerProps> = ({
    trackData,
    aggregatedTrackData,
    events,
}) => {
    return (
        <Marker
            // if position changes, marker will drift its way to new position
            position={
                aggregatedTrackData?.coordinates?.[0] &&
                aggregatedTrackData?.coordinates?.[0]?.[0] &&
                aggregatedTrackData?.coordinates?.[0]?.[1]
                    ? aggregatedTrackData?.coordinates[0]
                    : {}
            }
            icon={greenMarker}
        >
            <Popup>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                    }}
                >
                    {trackData?.locationPoints?.[0]?.deviceTimeEpoch ==
                    aggregatedTrackData?.selectedStartStoppagePoint ? (
                        trackData?.startAddress ? (
                            <>
                                <Typography
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                    }}
                                    variant="subtitle1"
                                >
                                    {events?.startEventDescription?.length > 0
                                        ? events?.startEventDescription
                                        : trackData?.startAddress ?? ''}
                                </Typography>
                                <Typography
                                    style={{
                                        fontWeight: 400,
                                        fontSize: 16,
                                    }}
                                    variant="subtitle1"
                                >
                                    {moment(
                                        parseInt(
                                            trackData?.locationPoints?.[0]
                                                ?.deviceTimeEpoch,
                                        ),
                                    ).format(
                                        'hh:mm A',
                                        // 'D MMM YYYY hh:mm A',
                                    )}
                                </Typography>
                            </>
                        ) : (
                            <></>
                        )
                    ) : (
                        aggregatedTrackData?.selectedStartStoppagePointLocationData &&
                        (['ORDER_PICKED', 'ORDER_DELIVERED'].includes(
                            aggregatedTrackData
                                ?.selectedStartStoppagePointLocationData?.type,
                        ) ? (
                            <>
                                {(function () {
                                    let popupInfo = {
                                        Description:
                                            aggregatedTrackData
                                                ?.selectedStartStoppagePointLocationData
                                                ?.title ?? '',
                                        ...aggregatedTrackData
                                            ?.selectedStartStoppagePointLocationData
                                            ?.properties,
                                    };
                                    return Object.keys(popupInfo)?.map(
                                        (key, index) => {
                                            return (
                                                <Box
                                                    style={{
                                                        width: 200,
                                                        marginTop:
                                                            index === 0
                                                                ? 20
                                                                : 0,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        justifyContent:
                                                            'space-between',
                                                    }}
                                                >
                                                    <Typography
                                                        gutterBottom
                                                        variant="body2"
                                                        component="div"
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        {key} :{' '}
                                                    </Typography>
                                                    <Typography
                                                        gutterBottom
                                                        variant="body2"
                                                        component="div"
                                                        style={{
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        {popupInfo[key]}
                                                    </Typography>
                                                </Box>
                                            );
                                        },
                                    );
                                })()}
                            </>
                        ) : (
                            <>
                                <Typography
                                    style={{
                                        fontWeight: 700,
                                        fontSize: 14,
                                    }}
                                    variant="subtitle1"
                                >
                                    {aggregatedTrackData
                                        ?.selectedStartStoppagePointLocationData
                                        ?.description?.length > 0 &&
                                    isNaN(
                                        Number(
                                            aggregatedTrackData
                                                ?.selectedStartStoppagePointLocationData
                                                ?.description,
                                        ),
                                    )
                                        ? aggregatedTrackData?.selectedStartStoppagePointLocationData?.description
                                              .split('@!@')
                                              .join(',')
                                        : 'No Location Available'}
                                </Typography>
                                <Typography
                                    style={{
                                        fontWeight: 400,
                                        fontSize: 16,
                                    }}
                                    variant="subtitle1"
                                >
                                    {moment(
                                        parseInt(
                                            aggregatedTrackData
                                                ?.selectedStartStoppagePointLocationData
                                                ?.startTime ??
                                                aggregatedTrackData
                                                    ?.selectedStartStoppagePointLocationData
                                                    ?.time,
                                        ),
                                    ).format(
                                        'hh:mm A',
                                        // 'D MMM YYYY hh:mm A',
                                    )}{' '}
                                    -{' '}
                                    {moment(
                                        parseInt(
                                            aggregatedTrackData
                                                ?.selectedStartStoppagePointLocationData
                                                ?.endTime ??
                                                aggregatedTrackData
                                                    ?.selectedStartStoppagePointLocationData
                                                    ?.time,
                                        ),
                                    ).format(
                                        'hh:mm A',
                                        // 'D MMM YYYY hh:mm A',
                                    )}{' '}
                                    (
                                    {getTimeAsDuration(
                                        getTimeDifference(
                                            parseInt(
                                                aggregatedTrackData
                                                    ?.selectedStartStoppagePointLocationData
                                                    ?.endTime ??
                                                    aggregatedTrackData
                                                        ?.selectedStartStoppagePointLocationData
                                                        ?.time,
                                            ),
                                            parseInt(
                                                aggregatedTrackData
                                                    ?.selectedStartStoppagePointLocationData
                                                    ?.startTime ??
                                                    aggregatedTrackData
                                                        ?.selectedStartStoppagePointLocationData
                                                        ?.time,
                                            ),
                                        ),
                                        'small',
                                    )}
                                    )
                                </Typography>
                            </>
                        ))
                    )}
                </div>
            </Popup>
        </Marker>
    );
};

export default StartPointMarker;
